/* ------------------------ Functional imports start ------------------------ */
import { Grid } from '@mui/material'
import React, { type ReactElement, useState } from "react";
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import GetConstant from '../../utils/constants'
import { type GuestRequest } from '../../utils/types'
/* ------------------------- Functional imports end ------------------------- */
/* -------------------------- Design imports start -------------------------- */
import MultilevelDrawer from '../../../../components/layout/MultilevelDrawer'
import { Form, type FormFieldType, type FormObject } from "../../../Form";
import { usePatchGuestRequest } from '../../hooks/useGuestRequestMutations'
import LogTool from '../../../../logger/logTools'

/* --------------------------- Design imports end --------------------------- */

type Props = {
  open: boolean
  setOpen: (open: boolean) => void
  onClose?: () => void
  formState: {
    state: GuestRequest | undefined
    setState: React.Dispatch<React.SetStateAction<GuestRequest | undefined>>
  }
  // onConfirm: (updatedGuestRequest: GuestRequest) => Promise<void>
  // dataSource: React.MutableRefObject<GuestRequest[]>
  // setFilteredData: React.Dispatch<React.SetStateAction<GuestRequest[]>>
}

/* -------------------------------------------------------------------------- */
/*                               Start Component                              */
/* -------------------------------------------------------------------------- */
export default function UnauthRequestDrawer(props: Props): ReactElement {
  /* -------------------------- Non state data start -------------------------- */
  const { open, setOpen, onClose, formState } = props
  const { t } = useTranslation()
  const log = new LogTool({ context: 'UnauthRequestDrawer', enable: true, logLevel: 'debug' })
  const patchGuestRequestMutation = usePatchGuestRequest()
  /* --------------------------- Non state data end --------------------------- */

  /* ---------------------------- Flag states start --------------------------- */
  const [isLoading, setIsLoading] = useState(false)
  /* ----------------------------- Flag states end ---------------------------- */

  /* -------------------------- Render constants start ------------------------ */
  const guestRequestFormFields: FormFieldType[] = GetConstant({ name: 'guestRequestEditFormFields' }) as FormFieldType[]
  /* --------------------------- Render constants end ------------------------- */

  /* ------------------------ Callback functions start ------------------------ */
  const handleUpdateGuestRequest = (): void => {
    if (!formState.state) {
      log.error('Form state is undefined')
      return
    }

    setIsLoading(true)
    patchGuestRequestMutation.mutate(
      {
        idOrSelf: formState.state.self,
        data: formState.state,
      },
      {
        onSuccess: () => {
          toast.success(t(
          'common:feedback.success.saved', { defaultValue: 'Successfully saved.', }
          ))
          setIsLoading(false)
          setOpen(false)
          onClose && onClose()
        },
        onError: (error) => {
          log.error('Error updating guest request', error)
          toast.error(
            t('common:feedback.error.savingFailed', {
              defaultValue: 'Saving failed.',
            })
          )
          setIsLoading(false)
        }
      }
    )
    try {

      // Update data source
      // const newDataSource = [...dataSource.current]
      // const index = dataSource.current.findIndex((g: GuestRequest) => g.self === updatedGuestRequest.self)
      // if (index > -1) {
      //   newDataSource[index] = updatedGuestRequest
      //   dataSource.current = newDataSource
      // }
      // setFilteredData(newDataSource)
    } catch (error) {

    }
  }
  /* ------------------------- Callback functions end ------------------------- */

  log.debug(
    'formState ->', formState.state,
  )

  /* -------------------------------------------------------------------------- */
  /*                              Render Component                              */
  /* -------------------------------------------------------------------------- */

  if (!formState.state) {
    return <></>
  }

  return (
    <MultilevelDrawer
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      title={t('common:content.label.editRequest') || ''}
      confirmButtonProps={{
        text: t('common:interaction.button.save'),
        onConfirm: handleUpdateGuestRequest,
        disabled: isLoading,
        hidden: false,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Form
            editing={true}
            formFields={guestRequestFormFields}
            formObject={formState.state}
            onChange={(value: FormObject) => {
              formState.setState(value as GuestRequest)
            }}
          />
        </Grid>
      </Grid>
    </MultilevelDrawer>
  )
}
